import styled from 'styled-components';

const SortIconTag = styled.i`
  margin-left: 1em;
`;

export default SortIconTag;
